<template>
  <div>
    <fragment v-if="form">
      <EndorsementForm
        :form="form"
        @submit="checkSubmit"
        name-button="SOLICITAR"
        @cancel="previousPageEndorsement"
        is-request-endorsement
        is-create
      />
    </fragment>
    <ModalGenericCriticism
      v-model="modal"
      @close="previousPageEndorsement"
      title="SOLICITAÇÃO DE ENDOSSO CRIADA"
      text="Nova solicitação de endosso foi criada com sucesso."
    />
    <ModalCancelEndoserment
      @close="closeModalCancel"
      v-model="modalCancelEndoserment"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
    <ModalConfirmReproveEndoserment
      @close="closeModalReprove"
      v-model="modalCancelReprove"
      title="CANCELAMENTO DE ENDOSSO"
      text="Você tem certeza de que deseja solicitar o cancelamento deste endosso. O cancelamento pode afetar a regra de cobertura prevista na apólice atual."
      has-cancel-button
      text-button="SIM"
    />
  </div>
</template>
<script>
import EndorsementForm from "../../policy/components/EndorsementForm";
import ModalGenericCriticism from "@/modules/quotation/components/ModalGenericCriticism";
import ModalCancelEndoserment from "../../insurance_company/components/ModalCancelInsurance";
import RequestEndorsementMixin from "@/mixins/RequestEndorsementMixin";
import ModalConfirmReproveEndoserment from "@/modules/quotation/components/ModalGenericCriticism";
import { formatDateToDDMMYYYY } from "@/utils/formats.js";
export default {
  data: () => ({
    form: null,
    modal: false,
    cloneForm: {},
    modalCancelReprove: false,
    formatDateToDDMMYYYY
  }),
  components: {
    EndorsementForm,
    ModalGenericCriticism,
    ModalCancelEndoserment,
    ModalConfirmReproveEndoserment
  },
  mixins: [RequestEndorsementMixin],
  methods: {
    checkSubmit(form) {
      if (form.tipo.id == "cancelamento_endosso") {
        this.openModalReprove();
      } else {
        this.submitNewRequestEndorsement(form);
      }
    },
    openModalReprove() {
      this.modalCancelReprove = true;
    },
    closeModalReprove(value) {
      this.modalCancelReprove = false;
      if (value) this.submitNewRequestEndorsement(this.form);
    },
    previousPageEndorsement() {
      this.modal = false;
      this.$router.push({
        name: "list request endorsement"
      });
    }
  }
};
</script>
